import React from "react";
import hombre from "../../../assets/svg/HOMBRE-2.svg";
import { connect } from "react-redux";
import * as exerciseService from "../../../services/exercise";
import "./modelos.css";

function Frente({ musculo, selectMusculo }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 458 587"
      width="458pt"
      height="587pt"
      className="svg"
    >
      <g>
        <svg
          viewBox="0 0 458 587"
          width="458pt"
          height="587pt"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <image height="450" width="298" x="70" y="-5" href={hombre} />
        </svg>
        <g
          onClick={() => selectMusculo("Calves")}
          className={"group " + (musculo === "Calves" ? "active" : "")}
        >
          <path
            d=" M 277 425 C 275.094 424.383 269.938 432.711 269 445 Q 268.062 457.289 270 471 Q 272.94 482.86 282 486 Q 286.328 487.5 294 485 Q 298.203 479.492 296 466 C 293.797 452.508 278.906 425.617 277 425 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="277.34301814063554"
            cy="468.49999999999983"
            rx="3.0238116991820334"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="277.343"
            y1="468.5"
            x2="58.316"
            y2="468.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <text transform="matrix(1,0,0,1,0,465.141)"> Pantorrillas</text>
        </g>
        <g
          onClick={() => selectMusculo("Quadriceps")}
          className={"group " + (musculo === "Quadriceps" ? "active" : "")}
        >
          <path
            d=" M 270 317 C 267.25 303.875 256.5 268.625 263 242 Q 269.5 215.375 245 288 Q 234.5 329.625 235 338 C 235.5 346.375 233.75 372.125 245 381 C 256.25 389.875 272.75 330.125 270 317 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="248.40980424735153"
            cy="333.4999999999999"
            rx="2.5959631692622906"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="248.41"
            y1="333.5"
            x2="60.374"
            y2="333.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <text transform="matrix(1,0,0,1,0,330.141)"> Cuadriceps </text>
        </g>
        <g
          onClick={() => selectMusculo("Abductors")}
          className={"group " + (musculo === "Abductors" ? "active" : "")}
        >
          <text transform="matrix(1,0,0,1,0,271.141)"> Abductores </text>
          <path
            d=" M 266 346 L 287 301 L 284 281 Q 273.938 229.994 263 229 Q 262.312 228.937 261 281 L 270 316 L 266 346 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="271.0909094436091"
            cy="274.49999999999983"
            rx="2.9090905563911633"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="271.091"
            y1="274.5"
            x2="60.374"
            y2="274.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
        </g>
        <g
          onClick={() => selectMusculo("Waist")}
          className={
            "group " + (musculo === "Waist" ? "active" : "")
          }
        >
          <path
            d=" M 298 157 L 294 155 Q 274.408 164.789 263.715 162.039 C 263.375 161.952 261.344 165.289 260 170.822 Q 259.349 173.503 260 177 L 265 183 L 265 196 L 269 213 L 267 217 L 266 223 L 269 234 Q 293.75 241.969 315 239 Q 315.219 238.969 323 223 L 325 215 L 322 205 L 323 204 L 329 192 L 329 183 L 325 180 L 326 174 L 330 168 L 330 165 L 332 162 L 332 160 L 336 156 L 306 157 L 302 155 L 298 157 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <circle
            vectorEffect="non-scaling-stroke"
            cx="284.5000000000002"
            cy="210.4999999999999"
            r="2.5000000000001137"
            fill="rgb(53,85,119)"
          />
          <line
            x1="282.476"
            y1="210.5"
            x2="58.316"
            y2="210.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <text transform="matrix(1,0,0,1,0,205.141)"> Abdominales </text>
        </g>
        <g
          onClick={() => selectMusculo("Chest")}
          className={"group " + (musculo === "Chest" ? "active" : "")}
        >
          <path
            d=" M 301 111 L 295 111 L 284 105 Q 263.988 95.078 253 110 Q 242.012 124.922 239 130 L 245 143 Q 257.376 162.825 262 163 C 294.367 164.227 295.836 148.477 297 150 Q 300.469 154.54 306 156 L 334 156 L 347 152 Q 355.094 145.75 357 143 C 358.906 140.25 364.402 128.091 366 126 Q 366.43 125.437 357 110 Q 347.943 97.984 339 96 Q 336.992 95.555 301 111 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="269.1214691349718"
            cy="149.4999999999999"
            rx="2.91030787580047"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="269.121"
            y1="149.5"
            x2="58.316"
            y2="149.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <text transform="matrix(1,0,0,1,0,145.141)"> Pectoral </text>
        </g>
        <g
          onClick={() => selectMusculo("Forearms")}
          className={"group " + (musculo === "Forearms" ? "active" : "")}
        >
          <path
            d=" M 175.625 29 Q 136 91.046 136 105 Q 136 111.656 151 120 Q 160.75 125.844 168 118 C 175.25 110.156 178.125 107.719 181 96 C 183.875 84.281 175.437 73.219 185 47 Q 185.742 44.966 175.625 29 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <text transform="matrix(1,0,0,1,0,62.141)"> Antebrazos </text>
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="157.97398798162595"
            cy="65.49999999999993"
            rx="2.551362404828268"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="157.974"
            y1="65.5"
            x2="58.316"
            y2="65.5"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
        </g>
        <g
          onClick={() => selectMusculo("Biceps Brachii")}
          className={"group " + (musculo === "Biceps Brachii" ? "active" : "")}
        >
          <path
            d=" M 231 115 C 231.807 116.383 220.977 122 214 122 Q 200.938 122 189 122 Q 178.523 116.117 178 109 Q 177.477 101.883 185 96 Q 196.336 89.367 205 93 C 213.664 96.633 221.539 98.789 231 115 Z "
            fill="rgb(248,120,96)"
            id="musculo"
          />
          <text transform="matrix(1,0,0,1,0,105.141)"> Bíceps </text>
          <ellipse
            vectorEffect="non-scaling-stroke"
            cx="193.16917169372186"
            cy="109.35720837811486"
            rx="2.199041266333552"
            ry="2.500000000000057"
            fill="rgb(53,85,119)"
          />
          <line
            x1="193.169"
            y1="109.357"
            x2="58.316"
            y2="109.357"
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgb(53,85,119)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
        </g>
      </g>
    </svg>
  );
}
const mapStateToProps = (state) => ({
  musculo: state.musculo,
});
const mapDispatchToProps = (dispatch) => ({
  selectMusculo(musculo) {
    //document.getElementById("loading").style.display = "block";
    dispatch({
      type: "SELECT_MUSCULO",
      musculo,
      apparatus: null,
      ejercicios: [],
    });
    /*exerciseService
      .getExercises(
        `exercisename=null&bodypart=null&musclegroup=${musculo}&apparatus=null&difficulty=null&utility_name=null&movement_name=null&apparatus_groups_name=null&mechanics=null&force=null&synergists=null&stabilizers=null&movement=null&subcategory=null&lang=es`
      )
      .then((res) => {
        var exercise = [];
        document.getElementById("loading").style.display = "none";
        for (const key in res.data.exercises) {
          if (Object.hasOwnProperty.call(res.data.exercises, key)) {
            exercise.push(res.data.exercises[key]);
          }
        }

      })
      .catch((err) => {
        document.getElementById("loading").style.display = "none";
        console.log(err);
      });*/
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Frente);
